import { Text as MantineText } from '@mantine/core';

export const LONG_DASH = '\u2013';
export const HYPHEN_MINUS = '\u002D';
export const BACKSLASH = (
	<MantineText fw="300" c="gray.4">
		&nbsp;/&nbsp;
	</MantineText>
);
export const NOT_APPLICABLE = 'N/A';
export const UndefinedItalic = <span style={{ fontStyle: 'italic' }}>Undefined</span>;
